import { MutationTree } from 'vuex'
import { AuditsState } from '@/store/modules/audits/auditsTypes'

export const mutations: MutationTree<AuditsState> = {
  FETCH_AUDITS(state, audits) {
    state.audits = audits
  }
}
